import { supabase } from '@/lib/supabase'
import { Session } from '@supabase/supabase-js'

export async function testSupabaseConnection(session: Session | null): Promise<boolean> {
  try {
    if (!session) {
      console.error('No session provided. Use useSession() hook.')
      return false
    }
    
    // If we got here, connection was successful
    console.log('🟢 Supabase connection successful')
    return true
  } catch (err) {
    console.error('Error testing Supabase connection:', err)
    return false
  }
}
